var exports = {
  "SW": "TableGamesEntry.module__popout___RU1kZz",
  "Ev": "TableGamesEntry.module__sheetBody___RU1kZz",
  "jw": "TableGamesEntry.module__chip___RU1kZz",
  "Go": "TableGamesEntry.module__chipName___RU1kZz",
  "F4": "TableGamesEntry.module__chipGame___RU1kZz",
  "qr": "TableGamesEntry.module__footer___RU1kZz",
  "Ci": "TableGamesEntry.module__chipRanked___RU1kZz",
};

module.exports = exports;
